import { baseTheme } from 'utils/themes/base'

import { ThemeI } from 'types/styled'

export const defaultTheme: ThemeI = {
  ...baseTheme,
}
